import * as React from "react";
import {Link} from "react-router-dom";
import {withRouter} from 'react-router';
import Element from "./Element";
import Axios from "../../Components/Axios";
import Cookies from "../../Components/Cookies";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';

class Menu extends React.Component{

    constructor(props) {
        super(props);
        this.state = {};
        this.state.current = this.props.current;
        this.state.data = JSON.parse(localStorage.wapClickMenu ?? null) ?? [];
    }

    componentDidMount() {
        Axios
            .get('api/menu')
            .then(r => {
                if(JSON.stringify(r.data) !== JSON.stringify(this.state.data)) {
                    this.setState({data: r.data});
                    localStorage.wapClickMenu = JSON.stringify(this.state.data);
                }
            })
            .catch(() => this.props.history.push('/'));
    }

    render() {
        return (
            <div className="container-fluid" key={this.state.current}>
                <nav className="navbar navbar-expand-lg navbar-light bg-white rounded mt-3 border-0 shadow">
                    <Link to="/" className="navbar-brand" >WAP-click</Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            {
                                this.state.data.map(v => <Element key = {v[0]} link = {v[0]} >{v[1]}</Element>)
                            }
                        </ul>
                        <ul className="navbar-nav ml-auto navbar-right">
                            <li className={`nav-link`} key={'exit'} >
                                <Link className="nav-link" to={'/auth/exit'}>Выход</Link>
                                { /*
                                <a className="nav-link" href = { backendUrl + 'api/exit/' + Cookies.getSession() }>Выход</a>
                                */ }
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

export default withRouter(Menu);

